const EntityStatus = require('@/lib/Entities/EntityStatus');
const TablePlan = require('@/lib/TablePlan/TablePlan');
const { toInt, toIntArray, toNullableInt, toNullableString } = require('@/functions/transform');

/**
 * @constructor
 */
const DeviceGroup = function () {
    /**
     * @type {number|null}
     */
    this.ID = null;

    /**
     * @type {number|null}
     */
    this.branchID = null;

    /**
     * @type {string}
     */
    this.name = '';

    /**
     * @type {string}
     */
    this.status = EntityStatus.ACTIVE;

    /**
     * @type {number[]}
     */
    this.favouriteItemIDs = [];

    /**
     *
     * @type {?TablePlan}
     */
    this.tablePlan = null;

    /**
     * Category id's for visible items.
     *
     * @type {number[]}
     */
    this.visibleCatIDs = [];
    /**
     * Event id's for visible items.
     *
     * @type {number[]}
     */
    this.visibleEventIDs = [];

    this.visibleItemIDs = [];
};

DeviceGroup.prototype = {
    getHydrationMap() {
        return {
            ID: {
                field: ['deviceGroupID', 'ID'],
                transform: toInt,
            },
            branchID: toNullableInt,
            name: toNullableString,
            status: toNullableString,
            favouriteItemIDs: toIntArray,
            tablePlan: { model: TablePlan },
            visibleCatIDs: toIntArray,
            visibleEventIDs: toIntArray,
            visibleItemIDs: toIntArray,
        };
    },

    /**
     * @returns {boolean}
     */
    hasVisibleItems() {
        return !!(
            this.visibleCatIDs.length
            || this.visibleEventIDs.length
            || this.visibleItemIDs.length
        );
    },
};

module.exports = DeviceGroup;
